import { Button, Text } from "@ui-component-library";

import RetryIcon from '@assets/icons/retry.svg';
import WarningIcon from '@assets/icons/warning-light-bg.svg';

export default function Retry({func}) {
  return <div className='flex flex-col flex-1 justify-center items-center p-8'>
    <div className='text-center max-w-[280px]'>
      <div className='flex justify-center mb-3'>
        <div className='border border-solid border-[#E5E5E5] rounded p-2'>
          <WarningIcon width='26px' />
        </div>
      </div>
      <Text variant='text-lg/leading-normal/semibold'>Något gick fel</Text>
      <Text className='text-[#737373] mb-4' variant='text-sm/leading-normal/normal'>Ett oväntat fel inträffade.</Text>
      {func && <Button size='small' className='w-full' onClick={() => func()}><RetryIcon height='20px' fill='#FAFAFA' /> Försök igen</Button>}
    </div>
  </div>
}
